import React from "react";
import { ManageCensusHistoryContainer } from "../../../containers";

const ManageCensusHistory = (props) => {
  return <ManageCensusHistoryContainer {...props} />;
};

export default ManageCensusHistory;
